export default () => {
    const sPopupTitleTpl = 'Вы уверены, что хотите отменить заказ #ORDER_NUMBER# ?';
    const oPopup = document.querySelector('.ds-popup-cancel-order');
    const oPopupOpenBtns = document.querySelectorAll('.ds-popup-cancel-order-open');

    if (oPopupOpenBtns.length === 0) {
        return;
    }

    const oPopupTitle = oPopup.querySelector('.popup__title');
    const oPopupForm = oPopup.querySelector('form.cancel-order__form');
    const oPopupOrderIdInput = oPopupForm.querySelector('input[name="order_id"]');
    const oPopupFormSubmitBtn = oPopupForm.querySelector('button[type="submit"]');
    const oPopupOtherReasonTextarea = oPopupForm.querySelector('textarea[name="other_reason"]');
    const oPopupReasonInputs = oPopupForm.querySelectorAll('input[name="cancel_reason"]');

    oPopupOpenBtns.forEach(oBtn => {
        const { id: iOrderId, number: sOrderNumber } = oBtn.dataset;

        oBtn.addEventListener('click', () => {
            oPopupTitle.textContent = sPopupTitleTpl.replace('#ORDER_NUMBER#', sOrderNumber || iOrderId);
            oPopupOrderIdInput.value = iOrderId;
        });
    });

    oPopupReasonInputs.forEach(oInput => {
        oInput.addEventListener('change', ({ target: oTarget }) => {
            if (oTarget.id === 'other' && oTarget.checked) {
                oPopupOtherReasonTextarea.style.display = 'block';
                oPopupOtherReasonTextarea.focus();
                oPopupFormSubmitBtn.disabled = true;
            } else {
                oPopupOtherReasonTextarea.style.display = '';
                oPopupOtherReasonTextarea.value = '';
                oPopupFormSubmitBtn.disabled = false;
            }
        });
    });

    oPopupOtherReasonTextarea.addEventListener('input', ({ target: oTarget }) => {
        if (oTarget.value.length > 0) {
            oPopupFormSubmitBtn.disabled = false;
        } else {
            oPopupFormSubmitBtn.disabled = true;
        }
    });

    oPopupForm.addEventListener('submit', oEvent => {
        oEvent.preventDefault();

        const oFormData = new FormData(oPopupForm);

        let iOrderId = oFormData.get('order_id'),
            sMessage = oFormData.get('cancel_reason');

        if (sMessage === 'other') {
            sMessage = oPopupOtherReasonTextarea.value;
        }

        if (!iOrderId || !sMessage || sMessage.length === 0) {
            return;
        }

        window.BX.ajax.runComponentAction(
            'ega:order.history',
            'cancelOrder',
            {
                mode: 'class',
                data: {
                    id: iOrderId,
                    message: sMessage
                }
            }
        ).then(({ data: oResponse }) => {
            if (oResponse.success) {
                const oOrderItemContainer = document.querySelector(`.order-item[data-id="${iOrderId}"] .order-item__container`);
                const oOrderItemStatus = oOrderItemContainer.querySelector('.order-item__status');
                const oOrderItemCancelBtn = oOrderItemContainer.querySelector('.ds-popup-cancel-order-open');
                const oOrderItemPaymentInfo = oOrderItemContainer.querySelector('.ds-order-payment-info');

                oOrderItemContainer.classList.add('canceled');
                oOrderItemStatus.textContent = oResponse.status;
                oOrderItemCancelBtn.style.display = 'none';

                if (oOrderItemPaymentInfo) {
                    oOrderItemPaymentInfo.style.display = 'none';
                }

                showResult(oResponse.message);
            }

            resetForm();
        }).catch(({ errors: arErrors }) => {
            const oError = arErrors[0];

            resetForm();
            showResult(oError.message);
        });

    });

    function resetForm() {
        oPopup.removeAttribute('data-open');
        oPopupOtherReasonTextarea.style.display = '';
        oPopupOtherReasonTextarea.value = '';
        oPopupForm.reset();
    }

    function showResult(sMessage) {
        $('.header-add-product').find('.header-add-product-title').html(sMessage).end().slideDown();
        setTimeout(() => {$('.header-add-product').find('.header-add-product-title').html('').end().slideUp();}, 5000);
    }
}